export default "__VITE_ASSET__DV35gBkl__"